<div class="take-course-container" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="5px">
	<loader [loader]="loader || readStateLoader" [type]="'general'"></loader>
	<ng-container *ngIf="( permissionError) && patchMessage">
		<div class="fx-row fx-center-start content-note">
			<div class="fx-row fx-center-start content-note">
				<div class="no-content-block" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="30px">
					<div fxLayoutAlign="center center">
						<mat-icon svgIcon="oops"></mat-icon>
					</div>
					<p class="caption-2">
						{{locale.translate(patchMessage)}}
					</p>
				</div>
			</div>
		</div>
	</ng-container>
	<ng-container *ngIf="!permissionError">
		<div class="take-course-block" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="18px"
			fxLayoutGap.xs="18px">
			<div class="take-course-header" fxLayout="column" fxLayoutAlign="start stretch">
				<div class="header-content" fxLayout="row" fxLayoutAlign="space-between center" fxLayout.xs="column"
					fxLayoutAlign.xs="start stretch">
					<div fxFlex="1 1" class="course-title">
						<span>{{ resourceDetail?.title }}</span>
					</div>
					<ng-container *ngIf="moduleList?.length">
						<div fxFlex="0 0 288px" fxFlex.xs="0 0" fxLayout="row" fxLayoutAlign="space-between center"
							fxLayoutGap="8px" fxLayoutGap.xs="3px">
							<div class="progress-info" fxFlex="1 0 20%" fxFlex.xs="auto" fxLayoutAlign="start center">
								<mat-progress-bar class="prog-br" color="primary" mode="determinate"
									[value]="completedPercentage">
								</mat-progress-bar>
							</div>
							<button class="arrow-btn" mat-icon-button (click)="toggleCourseList()">
								<mat-animated-icon [start]="'arrow_drop_down'" [end]="'arrow_drop_up'" colorStart="none"
									colorEnd="none" [animate]="showCourseList" [animateFromParent]="true"
									class="drop-icon" size="1em"></mat-animated-icon>
								<!-- <mat-icon class="drop-icon">{{ showCourseList ? 'arrow_drop_down' : 'arrow_drop_up' }}</mat-icon> -->
							</button>
						</div>
					</ng-container>
					<ng-container
						*ngIf="showCourseList && detectDevice?.resolutionState$?.value?.deviceType === 'mobile'">
						<div class="course-item-panel">
							<ng-container *ngIf="showCourseList" [ngTemplateOutlet]="courseItem"
								[ngTemplateOutletContext]="{}">
							</ng-container>
						</div>
					</ng-container>
				</div>
			</div>
			<!--body starts-->
			<div class="take-course-body" fxLayout="row" fxLayoutAlign="start stretch" fxLayoutGap="25px"
				fxLayout.xs="column">
				<div fxFlex="1 1" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
					<ng-container *ngIf="contentData && !loader">
						<ng-container *ngIf="contentData?.type === 'resource'">
							<ng-container *ngIf="!currentResourceDetail && !loader">
								<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px">
									<p class="no-data">{{locale.translate('no_course_content')}}</p>
								</div>
							</ng-container>
							<ng-container
								*ngIf="!['internalEvent', 'externalEvent', 'mooc'].includes(currentResourceDetail?.resourceTypeID?.key)">
								<ng-container
									*ngIf="currentResourceDetail?.resourceFormat?.key === 'image' && currentResourceDetail?.resource?.image?.length">
									<ng-container *ngIf="(detectDevice?.resolutionState$?.value?.xl  && currentResourceDetail?.resource?.image?.length <= 8)
										|| (detectDevice?.resolutionState$?.value?.lg && currentResourceDetail?.resource?.image?.length <= 6)
										|| ((detectDevice?.resolutionState$?.value?.md || detectDevice?.resolutionState$?.value?.sm) &&
										currentResourceDetail?.resource?.image?.length <= 4)
										|| (detectDevice?.resolutionState$?.value?.xs && currentResourceDetail?.resource?.image?.length <= 2)">
										<ng-container [ngTemplateOutlet]="imageReadability">
										</ng-container>
									</ng-container>

									<ng-container
										*ngIf="(detectDevice?.resolutionState$?.value?.xl  && currentResourceDetail?.resource?.image?.length > 8)
										|| (detectDevice?.resolutionState$?.value?.lg && currentResourceDetail?.resource?.image?.length > 6)
										|| ((detectDevice?.resolutionState$?.value?.md || detectDevice?.resolutionState$?.value?.sm ) &&
										currentResourceDetail?.resource?.image?.length > 4)
										||  (detectDevice?.resolutionState$?.value?.xs && currentResourceDetail?.currentResourceDetail?.resource?.image?.length > 2)">
										<app-readability class="app-readability" [height]="height"
											(readMore)="readMoreForImage($event)">
											<content>
												<ng-container [ngTemplateOutlet]="imageReadability">
												</ng-container>
											</content>
										</app-readability>
									</ng-container>

									<ng-template #imageReadability>
										<div class="img-container" fxLayout="column" fxLayoutAlign="start stretch">
											<div class="img-list" fxFlex="1 1" fxLayout="row wrap"
												fxLayoutAlign="start center" fxLayoutGap="24px" fxLayoutGap.xs="0px">
												<ng-container
													*ngFor="let image of currentResourceDetail?.resource?.image;let i = index;">
													<div class="img-item cursor-pointer" (click)="viewImage(i, image)"
														[ngClass]="{'xl' : detectDevice?.resolutionState$?.value?.xl,'lg' : detectDevice?.resolutionState$?.value?.lg,'md' : detectDevice?.resolutionState$?.value?.md,'sm' : detectDevice?.resolutionState$?.value?.sm, 'xs' : detectDevice?.resolutionState$?.value?.xs}">
														<div fxFlex="1 1" fxLayout.xs="column"
															fxLayoutAlign.xs="start stretch" fxLayoutGap.xs="5px">
															<div class="thumbnail">
																<img class="img" [src]="image?.file"
																	(error)="gfService.setErrorImage($event, 'broken_image'); image.error=true;">
																<ng-container
																	*ngIf="image?.caption && !detectDevice?.resolutionState$?.value?.xs">
																	<div class="thumbnail-overlay">
																		<p class="overlay-text">{{image?.caption}}</p>
																	</div>
																</ng-container>
															</div>
															<ng-container
																*ngIf="image?.caption && detectDevice?.resolutionState$?.value?.xs">
																<p class="caption-mob linkable" fxHide fxShow.xs>
																	{{image?.caption}}</p>
															</ng-container>
														</div>
													</div>
												</ng-container>
											</div>
										</div>
									</ng-template>

								</ng-container>

								<ng-container
									*ngIf="currentResourceDetail?.resourceFormat?.key === 'video' && currentResourceDetail?.resource?.file">
									<div class="file-container">
										<div class="ratio-player">
											<app-video-player [source]="currentResourceDetail?.resource?.file"
												[currentTime]="currentResourceDetail?.lastTimeline"
												[segmentsProcess]="!currentResourceDetail.read"
												[options]="{bookmarks: currentResourceDetail?.resource?.bookmark}"
												[canStartPlay]="canStartPlay"
												[thumbnail]="currentResourceDetail?.resource?.thumbnail"
												class="ratio-content" (segments)="segments($event)"
												(updatedTime)="updatedTime($event)">
											</app-video-player>
										</div>
									</div>
								</ng-container>

								<ng-container
									*ngIf="currentResourceDetail?.resourceFormat?.key === 'audio' && currentResourceDetail?.resource?.file">
									<app-audio-player [source]="currentResourceDetail?.resource?.file"
										[segmentsProcess]="!currentResourceDetail.read"
										[currentTime]="currentResourceDetail?.lastTimeline"
										[canStartPlay]="canStartPlay" class="resource-content audio-container"
										(segments)="segments($event)" (updatedTime)="updatedTime($event)">
									</app-audio-player>
								</ng-container>

								<ng-container *ngIf="currentResourceDetail?.resourceFormat?.key === 'document'">
									<ng-container *ngIf="currentResourceDetail?.resource?.file">
										<div class="resource-content document-container fx-column fx-start-stretch">
											<ng-container
												*ngIf="detectDevice?.resolutionState$?.value?.deviceType === 'desktop' && documentLoaded">
												<div class="object-tag-controls fx-row fx-space-between-stretch">
													<div></div>
													<div class="control">
														<button class="control-item btn-control" mat-icon-button
															(click)="fullScreen(objectData)">
															<mat-icon>fullscreen</mat-icon>
														</button>
													</div>
												</div>
											</ng-container>
											<object
												[data]="currentResourceDetail?.resource?.file | safeDom: 'resourceUrl'"
												type="application/pdf" width="100%" height="100%" class="viewer"
												[ngClass]="{'document-loaded': documentLoaded}" #objectData>
												<p>Your web browser doesn't have a PDF plugin.
													Instead you can <a
														[attr.href]="currentResourceDetail?.resource?.file"
														target="_blank">click
														here
														to
														download the PDF file.</a></p>
											</object>
										</div>
									</ng-container>
								</ng-container>

								<ng-container *ngIf="currentResourceDetail?.resourceFormat?.key === 'link'">
									<ng-container
										*ngIf="currentResourceDetail?.resource?.urlData?.isFormatted && currentResourceDetail?.resource?.urlData?.type === 'youtube'">
										<div class="resource-content embed-player-container">
											<loader [loader]="youtubeLoader"></loader>
											<div class="ratio-player">
												<div class="ratio-content">
													<div id="YTPlayer"></div>
												</div>
											</div>
										</div>
									</ng-container>
									<ng-container
										*ngIf="!currentResourceDetail?.resource?.urlData?.isFormatted || currentResourceDetail?.resource?.urlData?.type !== 'youtube'">
										<div class="embed-view view-gap"
											[ngClass]="{'fx-row fx-start-start' : !detectDevice?.resolutionState$?.value?.xs, 'fx-column fx-start-stretch' : detectDevice?.resolutionState$?.value?.xs}">
											<div class="thumbnail-block fx-no-grow fx-no-shrink">
												<div class="thumbnail cursor-pointer"
													(click)="embedLink(currentResourceDetail?.resource?.link)">
													<img [src]="currentResourceDetail?.resource?.thumbnail | safeDom : 'url'"
														(error)="gfService.setErrorImage($event, 'broken_image')"
														alt="">
												</div>
											</div>
											<div class="embed-content fx-column fx-start-stretch fx-grow fx-shrink">
												<ng-container *ngIf="currentResourceDetail?.title">
													<div class="fx-row fx-start-start">
														<P class="resource-title linkable"
															(click)="embedLink(currentResourceDetail?.resource?.link)">
															{{currentResourceDetail?.title}}</P>
														<mat-icon class="link-icon">open_in_new</mat-icon>
													</div>
												</ng-container>
												<ng-container *ngIf="currentResourceDetail?.resource?.link">
													<p class="sub-caption-2">{{locale.translate('source')}}</p>
													<p class="embed-url sub-caption-2 linkable"
														(click)="embedLink(currentResourceDetail?.resource?.link)">
														{{currentResourceDetail?.resource?.link}}</p>
												</ng-container>
											</div>
										</div>
									</ng-container>
								</ng-container>

								<ng-container *ngIf="currentResourceDetail?.resourceFormat?.key === 'page'">
									<ng-container *ngIf="currentResourceDetail?.resource?.innerHtml">
										<app-readability [height]="'275'" (readMore)="readMore($event)">
											<content>
												<div [innerHtml]="currentResourceDetail?.resource?.innerHtml | safeDom">
												</div>
											</content>
										</app-readability>
									</ng-container>
								</ng-container>
							</ng-container>

							<ng-container
								*ngIf="['internalEvent'].includes(currentResourceDetail?.resourceTypeID?.key)">
								<app-internal-event-detail [resourceDetail]="currentResourceDetail"
									(reloadResource)="reloadCurrentResource($event)">
								</app-internal-event-detail>
							</ng-container>
							<ng-container
								*ngIf="['externalEvent'].includes(currentResourceDetail?.resourceTypeID?.key)">
								<app-external-event-detail [resourceDetail]="currentResourceDetail"
									(reloadResource)="reloadCurrentResource($event)">
								</app-external-event-detail>
							</ng-container>
							<ng-container *ngIf="currentResourceDetail?.resourceTypeID?.key === 'mooc'">
								<app-mooc-detail [resourceDetail]="currentResourceDetail"
									(reloadResource)="reloadCurrentResource($event)"></app-mooc-detail>
							</ng-container>

						</ng-container>
						<ng-container *ngIf="contentData?.type === 'takeTest'">
							<app-take-test class="take-test-block" [testID]="contentData?.data"
								(startTest)="startTest($event)" (testDetail)="testDetail($event)">
							</app-take-test>
						</ng-container>
					</ng-container>
					<ng-container *ngIf="!contentData && !loader && moduleList?.length > 0">
						<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="15px">
							<p class="no-data">{{locale.translate('no_course_content')}}</p>
						</div>
					</ng-container>
					<ng-container *ngIf="moduleList?.length === 0 && !loader">
						<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px">
							<p class="no-data">{{locale.translate('no_module_found')}}</p>
						</div>
					</ng-container>
					<ng-container
						*ngIf="resourceDetail && resourceDetail?.settings?.commenting !== 'hide' && contentData?.type !== 'takeTest'">
						<div fxLayout="row" fxLayoutAlign="start start">
							<app-conversation [data]="{resourceData: resourceDetail}" fxFlex="0 1 760px"
								fxFlex.xs="auto">
							</app-conversation>
						</div>
					</ng-container>
				</div>
				<ng-container *ngIf="showCourseList && detectDevice?.resolutionState$?.value?.deviceType !== 'mobile'"
					[ngTemplateOutlet]="courseItem" [ngTemplateOutletContext]="{}">
				</ng-container>
			</div>
		</div>
	</ng-container>
</div>
<ng-container>
	<ng-template #courseItem let-data="data">
		<div fxFlex="1 1 288px" fxFlex.sm="1 1 200px" fxFlex.xs="auto" class="panel-list-container" fxLayout="column"
			fxLayoutAlign="start stretch" fxLayoutGap="10px">
			<!-- <ng-container>
			<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="15px">
				<p class="no-data">{{locale.translate('no_course_content')}}</p>
			</div>
	</ng-container> -->
			<ng-container *ngIf="moduleList?.length > 0">
				<div class="collapsible-container" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
					<ng-container
						*ngFor="let module of moduleList; let i = index; trackBy: gfService.trackByID.bind({'key': 'moduleID'})">
						<div fxLayout="column" fxLayoutAlign="start stretch" class="collapsible-block-item">

							<div *ngIf="module?.unlockAfterPrevious && i>0 && !moduleList[i-1]?.moduleCompleted;else elseBlock">
								<app-collapsible-block class="collapsible-block" [data]="{ svgIcon:  (module?.unlockAfterPrevious && i>0 && !moduleList[i-1]?.moduleCompleted) ? 'lock' : '' , title: module.moduleName}"
									[toggle]="{expanded: module?.opened, showToggle: true, closedIcon: 'expand_more', expandedIcon: 'expand_more'}"
									radius="5px" color="transparent" borderColor="var(--secondary-three)"
									(opened)="collapsibleToggle((module?.unlockAfterPrevious && i>0 && !moduleList[i-1]?.moduleCompleted), $event, module)">
									
								</app-collapsible-block>
							</div>
							<ng-template #elseBlock>
							<app-collapsible-block class="collapsible-block" [data]="{ svgIcon:  (module?.unlockAfterPrevious && i>0 && !moduleList[i-1]?.moduleCompleted) ? 'lock' : '' , title: module.moduleName}"
								[toggle]="{expanded: module?.opened, showToggle: true, closedIcon: 'expand_less', expandedIcon: 'expand_more'}"
								radius="5px" color="transparent" borderColor="var(--secondary-three)">
								<div header-insight class="comp-header">
									<div fxLayout="row" fxLayoutAlign="start center"
										fxLayoutAlign.xs="space-between stretch" fxLayoutGap="10px" fxFlex="1 0">
										<p class="body-text">{{(module?.activites?.length + module?.references?.length)
											||
											0}}</p>
									</div>
								</div>
								<div class="sub-content-area" fxLayout="column" fxLayoutAlign="start stretch"
									fxLayoutGap="20px" fxLayoutAlign.xs="start stretch">
									<ng-container *ngIf="!module?.activites?.length">
										<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="15px">
											<p class="no-data">{{locale.translate('no_course_content')}}</p>
										</div>
									</ng-container>
									<ng-container *ngIf="module?.activites?.length > 0">
										<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px"
											fxLayoutAlign.xs="start stretch">

											<div class="control-list" fxLayout="column" fxLayoutAlign="start stretch"
												fxLayoutAlign.xs="center stretch" fxLayoutGap="14px"
												fxLayoutGap.xs="10px">
												<ng-container
													*ngFor="let activity of module?.activites; let i = index; trackBy: gfService.trackByID.bind({'key': 'id'})">
													<div class="control-item" fxFlex="1 1 100%"
														[ngClass]="{'selected': activity?.selected}" fxLayout="row"
														fxLayoutAlign="start center" fxLayoutGap="8px"
														(click)=" setCourse(activity, i>0 && !activity?.read && module?.sequenceActivities && !module?.activites[i-1]?.read)">
														<div fxFlex="0 0 15px">
															<ng-container *ngIf="activity?.read ">
																<div class="tick-icon">
																	<mat-icon svgIcon="tick_mark"></mat-icon>
																</div>
															</ng-container>
															<ng-container *ngIf="i>0 && !activity?.read && module?.sequenceActivities && !module?.activites[i-1]?.read">
																<div class="lock-icon">
																	<mat-icon svgIcon="lock"></mat-icon>
																</div>
															</ng-container>
														</div>
														<div fxLayout="row" fxFlex="1 1 100%"
															fxLayoutAlign="start center" fxLayoutGap="13px">
															<!-- <mat-icon class="common-icon" [svgIcon]="activity?.contentType?.svgIcon"></mat-icon> -->
															<ng-container *ngIf="activity?.type === 'AT'">
																<mat-icon class="common-icon"
																	[svgIcon]="activity?.contentType?.svgIcon">
																</mat-icon>
															</ng-container>
															<ng-container *ngIf="activity?.type !== 'AT'">
																<ng-container
																	*ngIf="activity?.resourceFormat?.key === 'video'">
																	<mat-icon svgIcon="video_camera"
																		class="common-icon">
																	</mat-icon>
																</ng-container>
																<ng-container
																	*ngIf="activity?.resourceFormat?.key === 'audio'">
																	<mat-icon svgIcon="audio_headphone"
																		class="common-icon">
																	</mat-icon>
																</ng-container>
																<ng-container
																	*ngIf="activity?.resourceFormat?.key === 'page'">
																	<mat-icon svgIcon="pages" class="common-icon">
																	</mat-icon>
																</ng-container>
																<ng-container
																	*ngIf="activity?.resourceFormat?.key === 'link'">
																	<mat-icon svgIcon="external_link"
																		class="common-icon">
																	</mat-icon>
																</ng-container>
																<ng-container
																	*ngIf="activity?.resourceFormat?.key === 'document'">
																	<mat-icon svgIcon="document" class="common-icon">
																	</mat-icon>
																</ng-container>
																<ng-container
																	*ngIf="activity?.resourceFormat?.key === 'image'">
																	<mat-icon svgIcon="image_collection"
																		class="common-icon"></mat-icon>
																</ng-container>
																<ng-container
																	*ngIf="activity?.resourceFormat?.key === 'scorm'">
																	<mat-icon svgIcon="scorm"
																		class="common-icon"></mat-icon>
																</ng-container>
																<ng-container
																	*ngIf="['internalEvent', 'externalEvent'].includes(activity?.resourceTypeID?.key) && !activity?.resourceFormat?.key">
																	<mat-icon svgIcon="events"
																		class="common-icon"></mat-icon>
																</ng-container>
																<ng-container
																	*ngIf="['mooc'].includes(activity?.resourceTypeID?.key) && !activity?.resourceFormat?.key">
																	<mat-icon svgIcon="course"
																		class="common-icon"></mat-icon>
																</ng-container>
															</ng-container>

															<div fxLayout="column" fxFlex="0 1 100%" fxLayoutGap="8px">
																<span class="entity-title">{{activity?.title}}</span>
																<ng-container
																	*ngIf="![null, undefined, ''].includes(activity?.completedPercent) && activity?.completedPercent < 100">
																	<div fxFlex.xs="auto" fxLayoutAlign="start">
																		<mat-progress-bar class="progress-br"
																			color="primary" mode="determinate"
																			[value]=activity?.completedPercent>
																		</mat-progress-bar>
																	</div>
																</ng-container>
																<ng-container
																	*ngIf="[null, undefined, ''].includes(activity?.completedPercent) && activity?.type !== 'AT'">
																	<div fxFlex.xs="auto" fxLayoutAlign="start">
																		<mat-progress-bar class="progress-br"
																			color="primary" mode="determinate" value=0>
																		</mat-progress-bar>
																	</div>
																</ng-container>
															</div>
														</div>
													</div>
												</ng-container>
											</div>
										</div>
									</ng-container>

									<ng-container *ngIf="module?.references?.length">
										<div class="reference-block" fxLayout="column" fxLayoutAlign="start stretch"
											fxLayoutGap="10px">
											<app-collapsible-block class="collapsible-block"
												[data]="{title: locale.translate('references')}"
												[toggle]="{expanded: false, showToggle: true, closedIcon: 'expand_less', expandedIcon: 'expand_more'}"
												radius="5px" color="transparent" borderColor="var(--secondary-three)">

												<div header-insight class="comp-header">
													<div fxLayout="row" fxLayoutAlign="start center"
														fxLayoutAlign.xs="space-between stretch" fxLayoutGap="10px"
														fxFlex="1 0">

													</div>
												</div>
												<div class="sub-content-area" fxLayout="column"
													fxLayoutAlign="start stretch" fxLayoutGap="8px"
													fxLayoutAlign.xs="start stretch">

													<ng-container *ngFor="let reference of module?.references">
														<app-content-image-card [type]="'minimal'" [record]="reference"
															(detail)="loadResource(reference)"></app-content-image-card>
														<!-- <div class="resource-search-card cursor-pointer" fxLayout="row" fxLayoutAlign="start stretch"
														(click)="loadResource(reference)">

														<ng-container *ngIf="![null, undefined, ''].includes(reference.thumbnail)">
															<div fxFlex="0 0 90px" class="thumbnail-block">
																<div class="thumbnail">
																	<img [src]="reference.thumbnail"
																		(error)="gfService.setErrorImage($event, 'broken_image')">
																	<ng-container *ngIf="reference?.format">
																		<div class="img-overlay" fxLayout="row" fxLayoutAlign="center center">
																			<div class="format-icon" fxLayout="row" fxLayoutAlign="center center">
																				<ng-container *ngIf="reference?.format === 'video'">
																					<mat-icon svgIcon="video_camera"></mat-icon>
																				</ng-container>
																				<ng-container *ngIf="reference?.format === 'audio'">
																					<mat-icon svgIcon="audio_headphone"></mat-icon>
																				</ng-container>
																				<ng-container *ngIf="reference?.format === 'page'">
																					<mat-icon svgIcon="pages"></mat-icon>
																				</ng-container>
																				<ng-container *ngIf="reference?.format === 'link'">
																					<mat-icon svgIcon="external_link"></mat-icon>
																				</ng-container>
																				<ng-container *ngIf="reference?.format === 'document'">
																					<mat-icon svgIcon="document"></mat-icon>
																				</ng-container>
																				<ng-container *ngIf="reference?.format === 'image'">
																					<mat-icon svgIcon="image_collection"></mat-icon>
																				</ng-container>
																			</div>
																		</div>
																	</ng-container>
																</div>
															</div>
														</ng-container>
														<div class="search-card-content" fxFlex="1 1" fxFlex.xs="auto" fxLayout="column"
															fxLayoutAlign="start stretch" fxLayoutGap="4px">
															<div fxLayout="row" fxLayoutAlign="start start">
																<div class="sub-txt-patch"> {{reference.type}}</div>
															</div>
															<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
																<p class="card-title" fxFlex="1 1" fxFlex.xs="auto">
																	{{reference.title}}</p>
															</div>
														</div>
													</div> -->
													</ng-container>

												</div>
											</app-collapsible-block>
										</div>
									</ng-container>
								</div>
							</app-collapsible-block>
						</ng-template>
						</div>
					</ng-container>
				</div>
			</ng-container>
		</div>
	</ng-template>
</ng-container> 